// extracted by mini-css-extract-plugin
export var actions = "_j5-g";
export var benefitCard = "_j5-b";
export var benefitIcon = "_j5-d";
export var benefitLabel = "_j5-f";
export var benefits = "_j5-a";
export var benefitsSection = "_j5-8";
export var bodyText = "_j5-7";
export var closeButton = "_j5-2";
export var content = "_j5-3";
export var eyebrow = "_j5-4";
export var heading = "_j5-5";
export var image = "_j5-i";
export var imagePanel = "_j5-h";
export var modal = "_j5-0";
export var offerCard = "_j5-c";
export var offerIcon = "_j5-e";
export var sectionLabel = "_j5-9";
export var shell = "_j5-1";
export var title = "_j5-6";